module.exports = __webpack_public_path__ + "img/circle-copy.52f9b37f.svg";